export default __webpack_public_path__ + "static/media/Ballroll_00084.8dda8ba2.png";